// Centralized configuration constants for the ASOFOM Convention site
// Update these values here to propagate changes across both LandingPage and RegistroPage.

export const HUBSPOT_REGISTRATION_URL =
  'https://share.hsforms.com/1JMiT9Xo2TYKJxvLZagOX6A49wfh';

export const HUBSPOT_SPONSORSHIP_URL =
  'https://share.hsforms.com/1Ro13gadLRD6d6VEa9gxVHg49wfh';

// IMEF alliance — dedicated landing /ComunidadIMEF
export const HUBSPOT_IMEF_URL =
  'https://share.hsforms.com/1qm4DyCrRTOygSjz4tGIxXg49wfh';

// IMEF alliance — Golf tournament registration
export const HUBSPOT_IMEF_GOLF_URL =
  'https://share.hsforms.com/17QxVZH05QkmZFKPPCQAJyg49wfh';

// Short link used for cross-promo CTAs targeting the IMEF audience
export const IMEF_SHORT_URL = 'https://bit.ly/ConvenciónASOFOMIMEF';

// Fintech México alliance — short link for all Evento Sold Out CTAs
export const FINTECH_MEXICO_SHORT_URL = 'https://bit.ly/ASOFOMFintechMexico';

// ALECCC alliance — registration form
export const HUBSPOT_ALECCC_URL = 'https://share.hsforms.com/1rsZQe8eiQqmg5LA7Vlo-SA49wfh';

// Golf tournament registration (main convention, not IMEF)
export const GOLF_TOURNAMENT_URL = 'https://share.hsforms.com/17QxVZH05QkmZFKPPCQAJyg49wfh';

// Bowling tournament registration
export const BOWLING_TOURNAMENT_URL = 'https://share.hsforms.com/1Y-dmmOEgRT6O7WfKpTc1Kw49wfh';

// Race (5ta Carrera) registration
export const RACE_URL = 'https://share.hsforms.com/1LLN2SaQ7Sq-cSgxzk6ZRjg49wfh';

// Sponsorship kit PDF (for "Descargar Programa" placeholder if no agenda PDF yet)
export const AGENDA_PDF_URL =
  'https://customer-assets.emergentagent.com/job_d4b3d2e1-67da-40cf-8efa-61dbe3f79433/artifacts/v69sk0ff_ASOFOM%20Patrocinios%202026.pdf';

export const WHATSAPP_URL =
  'https://wa.me/525579311747?text=%C2%A1Hola!%20Quiero%20registrarme%20en%20la%2020%C2%B0%20Convenci%C3%B3n%20Nacional%20de%20ASOFOM';

// Pricing phase 1 ends at end of June 30, 2026
export const PHASE_1_END_DATE = '2026-06-30T23:59:59';

// Pricing phase 2 ends at end of August 7, 2026
export const PHASE_2_END_DATE = '2026-08-07T23:59:59';


// Convention starts August 26, 2026
export const EVENT_START_DATE = '2026-08-26T00:00:00';

// Pre-registro 21ª Convención Nacional 2027 (HubSpot)
export const PRE_REGISTRO_2027_URL = 'https://share.hsforms.com/1M429SpTYTlCcp8N2CPE7uw49wfh';
